import * as React from 'react';
import { useState } from 'react';
import { htmlIf } from '../../Utils/HTML';
import { updateWhere } from '../../Utils/Array';
import { PersonEvent, PersonEventCategory } from '../../Types/Person';
import EventCard from './EventCard';

type Props =
  { events: PersonEvent[]
  }

enum Tab
  { All
  , Sales
  , CustomerSuccess
  , Emails
  }

const EventList = (props: Props) => {
  const [events, setEvents] = useState(props.events);
  const [tab, setTab] = useState(Tab.All);

  const sortEventsLateToEarly = (events: PersonEvent[]) => {
    return events.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
  }

  const displayedEvents = () => {
    switch (tab) {
      case Tab.All:
        return sortEventsLateToEarly(events.filter(event => (
          event.category !== PersonEventCategory.TransactionalEmail
        )));
      case Tab.Emails:
        return sortEventsLateToEarly(events.filter(event => (
          [ PersonEventCategory.TransactionalEmail
          , PersonEventCategory.BroadcastEmail
          , PersonEventCategory.CampaignEmail
          ].includes(event.category)
        )));
      default:
        return [];
    }
  };

  const groupEventsByDate = (events: PersonEvent[]) => {
    return events.reduce<{ [key: string]: PersonEvent[] }>((accumulator, event) => {
      const dateKey = new Date(event.timestamp).toDateString();
      if (!accumulator[dateKey]) accumulator[dateKey] = [];
      accumulator[dateKey].push(event);
      return accumulator;
    }, {});
  };

  const groupedEvents = groupEventsByDate(displayedEvents());

  function updateEvent(updatedEvent: PersonEvent) {
    setEvents((prevEvents) =>
      updateWhere((event) => event.id === updatedEvent.id, updatedEvent, prevEvents)
    );
  }

  return (
    <>
      <div className="card rounded-2">
        <div className="border-bottom pb-0">
          <ul className="nav nav-tabs card-header-tabs p-3 pb-0">
            {[
              { label: 'All Activity', value: Tab.All },
              { label: 'Sales', value: Tab.Sales },
              { label: 'Customer Success', value: Tab.CustomerSuccess },
              { label: 'Emails', value: Tab.Emails }
            ].map(({ label, value }) => (
              <li key={label} className={`nav-item cursor-pointer me-1 ${tab === value ? 'mb-0 border-bottom border-primary' : ''}`}>
                <button
                  className={`btn btn-link nav-link rounded-0 border-0 cursor-pointer p-1 ${tab === value ? 'active' : 'fw-normal'}`}
                  onClick={() => setTab(value)}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="py-0 mb-1">
          {htmlIf(Object.entries(groupedEvents).length < 1,
            <div className="p-3 text-center">No events here!</div>
          )}
          {Object.entries(groupedEvents).map(([date, events]) => (
            <div key={date} className="">
              <div className="bg-gray-100 px-3 py-1 border-bottom border-gray-200">
                <div className="text-uppercase fs-sm fw-semibold">
                  {new Date(date).toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </div>
              </div>
              {events.map(event =>
                <EventCard
                  event={event}
                  onUpdate={updateEvent}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default EventList;
